import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

export default class FeedDesignOptions extends BaseOptionsBundle {

  optionTitle = "Design";
  static optionClassName = "i-feed-design";
  inspectorToolGroup = "feedDesign";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.GROUPED_OPTIONS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new BackgroundColor(),
      new BorderColor(),
      new BorderWidth(),
    ]);
  }
}
